// extracted by mini-css-extract-plugin
module.exports = {"container":"LiquidityDisclosure_container__aTp_D","link":"LiquidityDisclosure_link__jqh_D","title":"LiquidityDisclosure_title__3O6eB","text":"LiquidityDisclosure_text__wl1QG"};